import React, { FC } from 'react'
import styled from 'styled-components'

import { MediaGalleryInterface } from '../../../../graphql/magento'
import ImageWithMagnifier from './ImageWithMagnifier'

const ImageContainer = styled.div<{ $showPreviews: boolean }>`
  background: ${({ theme }) => theme.colors.coolGray.cool250};
  flex: 1;
  padding: 0 15px 8px 15px;
  text-align: center;
  width: 100%;

  @media (min-width: 600px) {
    height: auto;
    margin-left: auto;
    margin-right: ${({ $showPreviews }) => ($showPreviews ? '0' : 'auto')};
    max-height: 475px;
    max-width: 475px;
    padding: 0 0 8px 0;
  }
`

export interface ItemImageProps {
  className?: string
  image: MediaGalleryInterface
  showItemImagePreviews: boolean
}

const ItemImage: FC<ItemImageProps> = ({ className, image, showItemImagePreviews }) => {
  return (
    <ImageContainer $showPreviews={showItemImagePreviews} className={className}>
      <ImageWithMagnifier
        src={image.url || ''}
        alt={image.label || ''}
        magnifierWidth={450}
        magnifierHeight={350}
        zoomFactor={0.6}
      />
    </ImageContainer>
  )
}

export default ItemImage
